import "components/ui/Dialog/Dialog.scss"
import PropTypes from 'prop-types';
import { ReactComponent as IconClose } from "assets/images/icons/close.svg";
import { useEffect, useRef, useState } from "react";
import Button from "components/ui/Button/Button";
import Trans from "features/translation/components/Trans";
import { useDialog } from "context/DialogContext";
import Alert from "components/ui/Alert/Alert";
import Loader from "components/ui/Loader/Loader";

function Dialog({ title, errorTitle, errorMessage, loading, children, warnOnClose, scrollToTopIndicator }) {
  const { hideDialog } = useDialog();
  const [ showWarning, setShowWarning ] = useState(false);
  const dialogReference = useRef();

  const handleClose = () => {
    if (warnOnClose && !showWarning) {
      setShowWarning(true);
      return;
    }

    hideDialog();
  }

  const handleClickBackdrop = event => {
    if (event.target.classList.contains('dialog')) {
      handleClose();
    }
  }

  useEffect(
    () => {
      const handleEscape = event => {
        if (event.code === "Escape") {
          handleClose();
        }
      };
      window.addEventListener('keydown', handleEscape);
      return () => window.removeEventListener('keydown', handleEscape);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);

  useEffect(() => {
      dialogReference.current.scrollTo(0, 0);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      loading,
      showWarning,
      errorMessage,
      errorTitle,
      scrollToTopIndicator ]);

  return (
    <div className={ 'dialog' } onClick={ handleClickBackdrop } ref={ dialogReference }>
      <div className={ 'dialog__content' }>
        {
          showWarning &&
          <div className={ 'dialog__warning' }>
            <h2><Trans
              text={ 'Weet u zeker dat u het dialoog wilt sluiten? Alle wijzigingen worden niet opgeslagen.' }/></h2>
            <div className={ 'dialog__buttons' }>
              <Button onClick={ () => setShowWarning(false) }>Terug</Button>
              <Button onClick={ () => handleClose() } variant={ `secondary` }>Akkoord</Button>
            </div>
          </div>
        }
        <div onClick={ handleClose } className={ 'dialog__close' }>
          <IconClose/>
        </div>
        { title && <h2 className={ 'dialog__title' }>{ loading ? '' : title }</h2> }
        { loading && <Loader containerVariant={'center'}/> }
        { errorMessage && !loading && <Alert title={ errorTitle } message={ errorMessage }/> }
        { !loading && children }
      </div>
    </div>
  )
}

Dialog.propTypes = {
  title: PropTypes.string,
  error: PropTypes.string,
  loading: PropTypes.bool,
  warnOnClose: PropTypes.bool,
  scrollToTopIndicator: PropTypes.any,
}

export default Dialog;
